import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledLabel = styled.label`
  font-weight: ${(props: any) => themeUtilities.getFontWeight(props.theme, 'fontWeights.bolder')};
  font-size: ${(props: any) => themeUtilities.getFontSize(props.theme, 'default')}px;
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, 'input.labelColor')};
`

export default StyledLabel
